import { Injectable } from '@angular/core'
import { environment } from '../../environments/environment'

@Injectable()
export class httpConfig {
  constructor() {}

  // Centralized URL from environment configuration
  public ConnURL: string = environment.apiUrl + '/'

  public LocationURL: string = 'https://overpass-api.de/api/interpreter?'

  GetConnURL() {
    return this.ConnURL
  }

  GetLocationURL() {
    return this.LocationURL
  }
}
